import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ts-mosaic-tile-settings',
  templateUrl: './mosaic-tile-settings.component.html',
  styleUrls: ['./mosaic-tile-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MosaicTileSettingsComponent {
  @Input() tileSize: number;
  @Input() roiBoxVisible = false;

  @Output() tileSizeChanged = new EventEmitter<number>();
  @Output() roiBoxVisibleChanged = new EventEmitter<boolean>();
}
